import UserLayout from "../../components/UserLayout";
import MyPosts from "../../components/user/posts/MyPosts";

const MyPostPage = () => {
    return (
        <UserLayout>
            <MyPosts />
        </UserLayout>
    );
}

export default MyPostPage;